import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../shared/http-client';
import { Button } from '../../elements/button';
import { DatePicker } from '../../elements/date-picker';
import { FieldError } from '../../elements/field-error/field-error';
import FuelLevelChart from './FuelLevelChart';
/* import MileageBarChart from './MileageBarChart';
import ConsumptionBarChart from './ConsumptionBarChart'; */


export const FuelConsumption = () => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [fuelLevelData, setFuelLevelData] = useState<any[]>([]);
    const [percentLevelData, setPercentLevelData] = useState<any[]>([]);
    const [show1, setShow1] = useState(true);


    let obligado = {
        start_date: Yup.mixed().required('obligatorio'),
        end_date: Yup.mixed().required('obligatorio'),
        plate: Yup.mixed().required('obligatorio'),
    };
    const validacion = Yup.object().shape(obligado);

    const initialValues = {
        plate: null,
        start_date: '',
        end_date: ''
    };


    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);



    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        console.log('enviaremos', enviaremos)

        if (enviaremos.plate) {
            api(`/fleet/fuel-consumption/level-trend/?vehicle=${enviaremos.plate}&start_date=${enviaremos.start_date}&end_date=${enviaremos.end_date}`, 'GET');
        } else {
            api(`/fleet/fuel-consumption/level-trend/?`, 'GET');
        }
    };

    const handleShow1 = () => {
        setShow1(true);
    };

    const handleShow2 = () => {
        setShow1(false);
    };


    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
            }
        }

        if (state.data && state.path.includes('level-trend')) {
            setFuelLevelData(state.data.fuel_used || []);
            setPercentLevelData(state.data.percentage_fuel_level || []);
        }

        if (state.error) {
            if (state.error.error?.includes('No vehicle assignments found for driver')) {
                toast.error(`${t('common.error.driver-not-asigned')}`);
            }
        }
    }, [state.data]);

    return (
        <div className="relative z-10">
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="px-8 pt-4 text-[22px] text-gray-900">
                            {t('common.form-label.control-combustible')}
                        </div>
                        <div className='flex w-1/2 pl-8 pt-4'>
                            <div className=''><Button
                                onClick={handleShow1}
                                label={t('common.form-label.porcentaje-deposito')}
                                variant={!show1 ? 'gray' : 'primary'}
                            /></div>
                            <div className='pl-8'><Button
                                onClick={handleShow2}
                                label={t('common.form-label.litros-usados')}
                                variant={show1 ? 'gray' : 'primary'}
                            /></div>
                        </div>
                        <div className="px-8 pt-4">
                            <div className="flex justify-start">
                                <div className="pb-8 w-[300px]">
                                    <label className="text-gray-700 font-semibold text-sm mr-[33px] mt-2">
                                        {t('common.label.vehiculo')}:
                                    </label>
                                    <select
                                        value={values.plate ?? ""}
                                        onChange={e => setFieldValue('plate', e.target.value)}
                                        className="rounded-lg w-full border-gray-200"
                                    >
                                        <option value="">{t('common.label.todos')}</option>
                                        {vehicles.map(vehicle => (
                                            <option key={vehicle.id} value={vehicle.id}>
                                                {vehicle.plate}
                                            </option>
                                        ))}
                                    </select>
                                    <div className='pt-4'>
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'plate'}
                                        />
                                    </div>
                                </div>
                                <div className='w-[300px] pl-4'>
                                    <DatePicker
                                        name="start_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-inicio'
                                        )}
                                        value={

                                            values.start_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'start_date',
                                                value.start_date
                                                    ? dayjs(
                                                        value.start_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'start_date'}
                                    />
                                </div>
                                <div className='w-[300px] pl-4'>
                                    <DatePicker
                                        name="end_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-fin'
                                        )}
                                        value={

                                            values.end_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'end_date',
                                                value.end_date
                                                    ? dayjs(
                                                        value.end_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'end_date'}
                                    />
                                </div>
                                <div className="pl-8 pt-8">
                                    <Button
                                        label={t('common.button.search')}
                                        onClick={handleSubmit}
                                        disabled={state.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            {fuelLevelData.length > 0 && (
                <div>
                    {!show1 ? <div className="w-full pt-8 pb-2">
                        <FuelLevelChart data={fuelLevelData} tooltipLabel={t('common.form-label.litros-usados')} />
                    </div> :
                        <div>
                            <FuelLevelChart data={percentLevelData} tooltipLabel={t('common.form-label.porcentaje-deposito')} />
                        </div>}

                </div>

            )}
        </div>
    );


};